import { render, staticRenderFns } from "./ButacasPlanoGeneral.vue?vue&type=template&id=10008f20&scoped=true"
import script from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
export * from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
import style0 from "./ButacasPlanoGeneral.vue?vue&type=style&index=0&id=10008f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10008f20",
  null
  
)

export default component.exports